export const verify_wall_intro = {
  title: "Confirm your email",
  email_line: "Signed in as {email}",
};
